<template>
  <b-container fluid>
    <el-page-header
      @back="() => $refs.editForm.goBack()"
      :title="$l('INDEX.btn_go_back') || '返回'"
      :content="pageHeader"
    />
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <edit-form
            :disabled="isDisableEditForm"
            :yarnCode="params.yarnCode"
            :categoryCode="params.categoryCode"
            :pageType="pageType"
            ref="editForm"
          />
          <div class="d2-mt">
            <div class="d2-mt">
              <el-row>
                <el-col :span="20">
                  <el-button size="mini" @click="() => $refs.editForm.goBack()">
                    {{ $l('INDEX.btn_cancel') || '返回' }}
                  </el-button>
                  <el-button
                    v-if="!isDisableEditForm"
                    size="mini"
                    type="primary"
                    @click="() => $refs.editForm.save()"
                  >
                    {{ $l('INDEX.btn_save') || '保存' }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import EditForm from '../components/edit-form/index.vue'
export default {
  name: 'master-yarn-detail',
  components: {
    EditForm,
  },
  data() {
    return {}
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    pageHeader() {
      const types = {
        add: this.$l('form_label_yarn_add') ||'添加纱线明细信息',
        edit: this.$l('form_label_yarn_edit') ||'编辑纱线明细信息',
        detail: this.$l('form_label_yarn_detail') ||'纱线信息详情',
      }
      return types[this.pageType]
    },
    isDisableEditForm() {
      return this.pageType === 'detail'
    },
  },
  methods: {
    goBack() {},
    save() {
      this.$refs.editForm.save()
    },
  },
}
</script>
